export { default } from './useNextPageTrigger';